import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { isFaceNotFoundBudgetExceeded, isFaceNotFoundLastWarning } from "../../utils/faceNotFoundBudget";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal({ onConfirm, open, isMongoUpdated, examDetail, faceNotFoundCount, MonitoringData }) {

  const classes = useStyles();


  return (
    <div>
      <Modal
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
              Face Not Found
            </h3>
            <p id="transition-modal-description">
              {MonitoringData.result.photo_action === "S" && isFaceNotFoundBudgetExceeded(examDetail, faceNotFoundCount) ? (
                <>
                  We are Sorry to inform you that your {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"} has been terminated due to continued face verification failures.
                </>
              ) : MonitoringData.result.photo_action === "S" && isFaceNotFoundLastWarning(examDetail, faceNotFoundCount) ? (
                <>
                  We can't see your face. Please keep your face in front of the camera, in good light. If your camera is covered or switched off, uncover it or switch it on. <u style={{ color: 'red' }}><b>ONCE MORE</b></u> face-verification failure will result in automatic submission of your assessment and will be recorded as a proctoring violation.
                </>
              ) : (
                <>
                  We can't see your face. Please keep your face in front of the camera, in good light. If your camera is covered or switched off, uncover it or switch it on. Continued face-verification failure will result in automatic submission of your assessment and will be recorded as a proctoring violation.
                </>
              )}
            </p>
            {isMongoUpdated !== true && (
              <p style={{ textAlign: "center", marginBottom: "10px" }}>Saving your responses...</p>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              {/* The OK button must always be reachable - if the background violation
                  save (isMongoUpdated) never succeeds (exhausted retries on a bad
                  connection), this used to hide the button entirely with no way to
                  dismiss the modal short of reloading the page. */}
              <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                <strong>Ok</strong>
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
